import React, {memo} from 'react'
import cx from 'classnames'

/* Styles */
import s from './info-message.scss'

const InfoMessage = memo(
  ({children, iconClassNames, chevronRight, className, onClick}
  ) => {

    const handleOnclick = () => {
      if (onClick) {
        onClick()
      }
    }

    return (
      <button className={cx(s.root, className)} onClick={() => handleOnclick()}>
        <div className={s.infoMessageContent}>
          <i className={iconClassNames} aria-hidden/>
          <span className={s.locationText}>{children}</span>
        </div>
        {chevronRight ? <i className={s.chevronRight}/> : null}
      </button>
    )
  }
)

export default InfoMessage
